import React, { useState } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  FaUser, FaSignOutAlt, FaCog, FaHome, FaGraduationCap, FaBars,
  FaClipboardList, FaCalendarAlt, FaUserGraduate, FaUsers,
  FaCheckCircle, FaFileAlt, FaChalkboardTeacher
} from 'react-icons/fa';
import '../assets/css/Navigation.css';

const Navigation = () => {
  const { currentUser, userRole, logout, userVerified } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  // Check if a path is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="custom-navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand text-center mb-3">
          <img 
            src="/logo-rekos.png" 
            alt="Logo Rekayasa Kosmetik" 
            className="navbar-logo" 
          />
          <span className="d-none d-lg-inline" style={{ fontSize: '0.9rem', lineHeight: '1.2' }}>
            Sistem Tugas Akhir Rekayasa Kosmetik
          </span>
          <span className="d-inline d-lg-none">STAR Kosmetik</span>
        </Link>
        <button 
          className="navbar-toggle d-lg-none" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <FaBars />
        </button>
        <div className={`navbar-menu ${isMenuOpen ? 'show' : ''}`}>
          <Nav className="flex-column">
            {currentUser && (
              <>
                <Nav.Link 
                  as={Link} 
                  to="/dashboard" 
                  className={isActive('/dashboard') ? 'active-nav-link' : ''}
                >
                  <FaHome /> Dashboard
                </Nav.Link>
                {/* Tampilkan menu lain HANYA jika user sudah diverifikasi */}
                {userVerified === true && (
                  <>
                    {userRole === 'mahasiswa' && (
                      <>
                        <div className="menu-section">Menu Mahasiswa</div>
                        <Nav.Link 
                          as={Link} 
                          to="/pendaftaran-ta" 
                          className={isActive('/pendaftaran-ta') ? 'active-nav-link' : ''}
                        >
                          <FaGraduationCap /> Pendaftaran TA
                        </Nav.Link>
                        <Nav.Link 
                          as={Link} 
                          to="/bimbingan" 
                          className={isActive('/bimbingan') ? 'active-nav-link' : ''}
                        >
                          <FaClipboardList /> Bimbingan
                        </Nav.Link>
                        <Nav.Link 
                          as={Link} 
                          to="/seminar" 
                          className={isActive('/seminar') ? 'active-nav-link' : ''}
                        >
                          <FaCalendarAlt /> Seminar & Sidang
                        </Nav.Link>
                      </>
                    )}
                    {userRole === 'dosen' && (
                      <>
                        <div className="menu-section">Menu Dosen</div>
                        <Nav.Link 
                          as={Link} 
                          to="/mahasiswa-bimbingan" 
                          className={isActive('/mahasiswa-bimbingan') ? 'active-nav-link' : ''}
                        >
                          <FaUserGraduate /> Mahasiswa Bimbingan
                        </Nav.Link>
                        <Nav.Link 
                          as={Link} 
                          to="/mahasiswa-uji" 
                          className={isActive('/mahasiswa-uji') ? 'active-nav-link' : ''}
                        >
                          <FaChalkboardTeacher /> Mahasiswa Uji
                        </Nav.Link>
                      </>
                    )}
                    {userRole === 'pj' && userVerified && (
                      <>
                        <div className="menu-section">Menu Admin</div>
                        <Nav.Link 
                          as={Link} 
                          to="/verifikasi-akun" 
                          className={isActive('/verifikasi-akun') ? 'active-nav-link' : ''}
                        >
                          <FaCheckCircle /> Verifikasi Akun
                        </Nav.Link>
                        <Nav.Link 
                          as={Link} 
                          to="/kelola-ta" 
                          className={isActive('/kelola-ta') ? 'active-nav-link' : ''}
                        >
                          <FaFileAlt /> Kelola Tugas Akhir
                        </Nav.Link>
                        <Nav.Link 
                          as={Link} 
                          to="/kelola-seminar" 
                          className={isActive('/kelola-seminar') ? 'active-nav-link' : ''}
                        >
                          <FaUsers /> Kelola Seminar & Sidang
                        </Nav.Link>
                        <Nav.Link 
                          as={Link} 
                          to="/admin" 
                          className={isActive('/admin') ? 'active-nav-link' : ''}
                        >
                          <FaCog /> Admin Panel
                        </Nav.Link>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </Nav>
          
          <Nav className="mt-auto">
            {currentUser ? (
              <NavDropdown 
                title={
                  <div className="d-flex align-items-center">
                    <div className="user-avatar">
                      <FaUser />
                    </div>
                    <span className="ms-2 d-none d-lg-inline">
                      {currentUser.displayName || currentUser.email}
                    </span>
                  </div>
                } 
                id="user-dropdown"
                align="end"
                className="user-dropdown"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  <FaCog className="me-2" /> Profil Saya
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  <FaSignOutAlt className="me-2" /> Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <>
                <Nav.Link 
                  as={Link} 
                  to="/login" 
                  className={isActive('/login') ? 'active-nav-link' : ''}
                >
                  Login
                </Nav.Link>
                <Nav.Link 
                  as={Link} 
                  to="/register" 
                  className={isActive('/register') ? 'active-nav-link' : ''}
                >
                  Register
                </Nav.Link>
              </>
            )}
          </Nav>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
